import IndexView from './views/index';
import CreateView from './views/commission-terms/create';
import UpdateView from './views/commission-terms/_id';

export const views = {
  index: IndexView,
  create: CreateView,
  edit: UpdateView,
};
